module.exports = __webpack_public_path__ + "img/Bank Of China.125089b0.png";